import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Divider,
  Stack,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { SectionTitle } from './styles';
import { useEffect } from 'react';
export const AffectedProducts = ({ member }) => {
  // Check if products exist and are not empty
  const hasProducts = member.response.products && member.response.products.length > 0;
  console.log(member.response.products)
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <SectionTitle variant="h6">Product List</SectionTitle>

      {hasProducts ? (
        <Box sx={{ flexGrow: 1 }}>
          <Paper variant="outlined" sx={{ mb: 2 }}>
            {member.response.products.map((product, idx) => {
              const isTbd = product.isAffected === null || product.isAffected === undefined;
              return (
              <React.Fragment key={`${product.productId}-${idx}`}>
                {idx > 0 && <Divider />}
                <Box sx={{ p: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {product.productName}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        CUC: {product.productCucNumber || 'N/A'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 22,
                          height: 22,
                          borderRadius: '50%',
                          bgcolor: isTbd ? '#9e9e9e' : product.isAffected ? '#ff9800' : '#4caf50',
                          mr: 1,
                          color: 'white'
                        }}>
                          {isTbd ?
                            <HelpOutlineIcon sx={{ color: 'white', fontSize: 16 }} /> :
                            product.isAffected ?
                              <PriorityHighIcon sx={{ color: 'white', fontSize: 16 }} /> :
                              <CheckIcon sx={{ color: 'white', fontSize: 16 }} />
                          }
                        </Box>
                        <Typography variant="body2" fontWeight="medium">
                          {isTbd ? "To be Determined" : product.isAffected ? "Impacted" : "Not Impacted"}
                        </Typography>
                      </Box>

                      {/* Only show comment section if the product has a comment */}
                      {product.comment && product.comment.trim() !== '' && (
                        <Paper variant="outlined" sx={{ p: 1, bgcolor: "#fafafa" }}>
                          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                            {product.comment}
                          </Typography>
                        </Paper>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              </React.Fragment>
              );
            })}
          </Paper>
        </Box>
      ) : (
        <Paper variant="outlined" sx={{ p: 2, bgcolor: "#f5f7ff", textAlign: "center" }}>
          <Stack direction="column" spacing={1} alignItems="center" justifyContent="center">
            <InfoIcon color="info" fontSize="large" />
            <Typography variant="body1">
              No products were submitted with this impact assessment.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              The member may not have any products containing this ingredient or may have chosen not to report any.
            </Typography>
          </Stack>
        </Paper>
      )}
    </Box>
  );
};
